const semanticClassNames = {
  root: 'text-effect',
} as const;

export default semanticClassNames;
